import { render, staticRenderFns } from "./termsServicePage.vue?vue&type=template&id=5c5e4b68&"
import script from "./termsServicePage.vue?vue&type=script&lang=js&"
export * from "./termsServicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports